import { create } from "zustand";
import { jwtDecode } from "jwt-decode";

export const useAuthStore = create((set) => ({
  token: null,
  user: null,
  role: null,
  email: null,
  isAuthenticated: false,

  
  initializeAuth: () => {
    const token = localStorage.getItem("authToken");
    if (token) {
      try {
        const decoded = jwtDecode(token);
        const role =
          decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        const email =
          decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];

        set({
          token,
          role,
          email,
          user: decoded,
          isAuthenticated: true,
        });
      } catch (error) {
        console.error("Error decoding token:", error);
        localStorage.removeItem("authToken");
      }
    }
  },

  
  login: (token) => {
    localStorage.setItem("authToken", token);
    try {
      const decoded = jwtDecode(token);
      const role =
        decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
      const email =
        decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];

      set({
        token,
        role,
        email,
        user: decoded,
        isAuthenticated: true,
      });
    } catch (error) {
      console.error("Error decoding token:", error);
    }
  },

  //  Logout action (clear all)
  logout: () => {
    localStorage.removeItem("authToken");
    set({
      token: null,
      user: null,
      role: null,
      email: null,
      isAuthenticated: false,
    });
  },
}));